import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/service.css";
import services from "../assets/data/service.json";

const Service = () => {
    const { t } = useTranslation();
    const skillsRef = useRef(null);

    useEffect(() => {
        if (!skillsRef.current) {
            return;
        }

        const element = skillsRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add("visible");
                    } else {
                        element.classList.remove("visible");
                    }
                });
            },
            {
                threshold: 0.1,
            },
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <div className="service" id="services" ref={skillsRef}>
                <div className="head">
                    <h1>{t("service.title")}</h1>
                    <h4>{t("service.subtitle")}</h4>
                    <hr></hr>
                </div>

                {/* Services */}

                <div className="service-cat">
                    {services.map((service, index) => (
                        <div className="service-item" key={index}>
                            <div>
                                <h3>{t(service.titleKey)}</h3>
                                <p>{t(service.descriptionKey)}</p>
                            </div>
                            <div>
                                <i className={service.icon}></i>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Service;
